import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';
import { ImportExcel } from 'components/Tvendo/Common/ImportExcel';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsFindBy } from 'services/WService';

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);
  const [zones, setZones] = useState([]);
  const [supervisors, setSupervisors] = useState([]);
  const [dataExcel, setDataExcel] = useState(undefined);
  const [dataImport, setDataImport] = useState({});

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listZones() {
    let response = await wsGetAll('base/zone');
    if (response.success) setZones(response.data);
  }

  async function listSupervisors(zone) {
    let response = await wsFindBy('base/supervisor-v2', { state: 'A', deleted: 'null', codsede: zone });
    if (response.success) setSupervisors(response.data);
  }

  const sellers = supervisors.find(
    sup => String(sup.id) === String(dataChanging.base_supervisor_id)
  )?.sellers || [];

  useEffect(() => {
    if (cuota.open) {
      setDataChanging([]);
      listZones();
    }
    setDataExcel(undefined);
  }, [cuota.open]);

  useEffect(() => {
    if (zones.length > 0 && cuota.codsede) {
      handleChange("codsede", String(cuota.codsede));
    }
  },[zones]);

  useEffect(() => {
    if (dataChanging.codsede !== undefined && dataChanging.codsede !== null) {
      listSupervisors(dataChanging.codsede);
    }
  },[dataChanging.codsede]);

  useEffect(() => {
    if (supervisors.length > 0 && cuota.codSupervisor) {
      handleChange("codSupervisor", String(cuota.codSupervisor));
    }
  },[supervisors]);

  useEffect(() => {
    if (dataImport?.success) {
      console.log("Importación exitosa", dataImport);
  
      setDataChanging((prev) => ({
        ...prev,
        base_zone_id: null,
      }));
  
      setDataExcel({
        success: dataImport.success,
        sellers: dataImport.data.map((item) => {
          return {
            base_zone_code: item.SEDE,
            SlpCode: item.VENDEDOR,
            tipo: item.TIPO,
            cuota: item.CUOTA,
          };
        }),
      });
    } else if (dataImport?.success === false) {
      console.log("Importación fallida", dataImport);
      setDataExcel(undefined);
    }
  }, [dataImport]);

  return (
    <>
      <Modal
        title={`Nueva Cuota de vendedor para Verdum`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity={
          dataExcel?.success
            ? 'sale/cuota-verdum-vendedor/multiple'
            : 'sale/cuota-verdum-vendedor'
        }
        dataForce={
          dataExcel?.success
            ? {
                sellers: dataExcel?.sellers,
              }
            : {
                base_zone_id: dataChanging.base_zone_id,
                base_supervisor_id: dataChanging.base_supervisor_id,
                base_seller_id: dataChanging.base_seller_id,
                base_canal_id: dataChanging.base_canal_id
              }
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <span style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Autocomplete
            disableClearable
            options={zones}
            getOptionLabel={(item) => `${item.description}`}
            renderInput={(params) => (
              <TextField {...params} label="Sede" margin="normal" fullWidth />
            )}
            onChange={(e, item) => {handleChange('base_zone_id', item?.id);handleChange('codsede', item?.code);setDataImport(null);}}
            value={zones.find((zone) => String(zone.id) === String(dataChanging.base_zone_id)) || null }
            style={{ flexGrow: 1, marginRight: '10px' }}
          />
          <ImportExcel
            setDataImport={setDataImport}
            btnColor="success"
            validDuplicate={['VENDEDOR','TIPO']}
            sortDuplicate={['VENDEDOR','TIPO']}
            downTemplate={{
              fileNameDown: `${moment(cuota?.valueSearch?.Periodo).format('YYYY-MM')}_Plantilla de cuota para vendedor verdum`,
              fields: ['SEDE','VENDEDOR','TIPO','CUOTA']
            }}
          />
        </span>
        {dataImport?.success && (
          <p style={{ color: '#07c107', marginTop: '10px', fontSize: '14px' }}>
            Archivo importado: {dataImport.nameFile}
          </p>
        )}
        {!dataImport?.success ? (
          <>
            <Autocomplete
              disableClearable
              options={supervisors}
              getOptionLabel={(item) => `${item.name}`}
              renderInput={(params) => (
                <TextField {...params} label="Supervisor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => {handleChange('base_supervisor_id', item?.id);}}
              value={supervisors.find((sup) => String(sup.id) === String(dataChanging.base_supervisor_id)) || null }
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <Autocomplete
              disableClearable
              options={sellers}
              getOptionLabel={(item) => `${item.SlpName}`}
              renderInput={(params) => (
                <TextField {...params} label="Vendedor" margin="normal" fullWidth />
              )}
              onChange={(e, item) => { handleChange('base_seller_id', item?.id);handleChange('base_canal_id', item?.base_canal_id);}}
              value={sellers.find((sel) => String(sel.id) === String(dataChanging.base_seller_id)) || null}
              style={{ flexGrow: 1, marginRight: '10px' }}
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo</InputLabel>
              <Select
                required
                defaultValue={!!cuota ? cuota.tipo : ''}
                inputProps={{
                  name: 'tipo',
                }}
              >
                <MenuItem value="O">Venta</MenuItem>
                <MenuItem value="C">Cobertura</MenuItem>
                <MenuItem value="I">Compra</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Cuota"
              fullWidth
              type="number"
              name="cuota"
              margin="normal"
              defaultValue={!!cuota ? cuota.cuota : ''}
              onChange={(e) => handleChange('cuota', e.target.value)}
              required
            />
          </>
        ) : undefined}
      </Modal>
    </>
  );
});

